export default __webpack_public_path__ + "static/media/OLove.88387459.svg";